import api from "../utils/axios";

export const getCompanies = async (params) => {
  const response = await api.get('/admin/companies', { params });
  return response.data;
};

export const createCompany = async (companyData) => {
  const response = await api.post('/admin/businesses', companyData);
  return response.data;
};

export const updateCompany = async (companyId, companyData) => {
  const response = await api.put(`/admin/companies/${companyId}`, companyData);
  return response.data;
};

export const uploadCompanyLogo = async (companyId, file) => {
  const formData = new FormData();
  formData.append("logo", file);
  const response = await api.post(`/admin/companies/${companyId}/logo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteCompany = async (companyId) => {
  const response = await api.delete(`/admin/companies/${companyId}`);
  return response.data;
};

export const getCompany = async (companyId) => {
  const response = await api.get(`/admin/companies/${companyId}`);
  return response.data;
};

export const getCompanyDetail = async (companyId) => {
  const response = await api.get(`/admin/companies/${companyId}/detail`);
  return response.data;
}; 